import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
    const { user, loading } = useAuth();
    const loc = useLocation();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="font-mono text-sm text-muted-foreground">
                    <span className="pulse-dot">◉</span> Verifying session…
                </div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
    if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
    return children;
}
